import { jsx as a, jsxs as x, Fragment as h } from "react/jsx-runtime";
import { useState as B } from "react";
import { isNumber as b, isString as g, isNull as N, isUndefined as j, isBoolean as F } from "lodash-es";
import { keyToWord as S } from "../../utils/common/index.js";
import "../../../dayjs.min-Cn_pDfYJ.js";
import { Empty as v, Form as A, Input as T } from "antd";
import { ActionButton as M } from "../ActionButton/index.js";
const q = ({ record: t, columns: p, editable: l = !1 }) => {
  const [m, I] = B(!1);
  if (!t) return /* @__PURE__ */ a(v, { image: v.PRESENTED_IMAGE_SIMPLE });
  const V = Object.keys(t).map((i) => {
    if (b(t == null ? void 0 : t[i]) || g(t == null ? void 0 : t[i]) || N(t == null ? void 0 : t[i]) || j(t == null ? void 0 : t[i]) || F(t == null ? void 0 : t[i]))
      return {
        key: i,
        title: S(i),
        dataIndex: i
      };
    if (Array.isArray(t == null ? void 0 : t[i]) && ((t == null ? void 0 : t[i]) || []).every(
      (s) => b(s) || g(s) || N(s) || j(s)
    ))
      return {
        key: i,
        title: S(i),
        dataIndex: i,
        render: (s, n, f) => l && m ? /* @__PURE__ */ a(
          A.Item,
          {
            className: "m-0",
            name: [i],
            initialValue: n == null ? void 0 : n[i],
            children: /* @__PURE__ */ a(T, {})
          }
        ) : s.join(", ")
      };
  }).filter((i) => !!i), _ = (i, s) => {
    var E;
    const n = i == null ? void 0 : i.render, f = i == null ? void 0 : i.dataIndex;
    return n ? n(t == null ? void 0 : t[f], t, s, l) : l && m ? /* @__PURE__ */ a(
      A.Item,
      {
        className: "m-0",
        name: [f],
        initialValue: t == null ? void 0 : t[f],
        children: /* @__PURE__ */ a(T, {})
      }
    ) : (E = t == null ? void 0 : t[f]) == null ? void 0 : E.toString();
  };
  return /* @__PURE__ */ x(h, { children: [
    l && /* @__PURE__ */ a("div", { className: "flex justify-end mb-4", children: /* @__PURE__ */ a(
      M,
      {
        onEdit: () => I(!0),
        onCancel: () => I(!1)
      }
    ) }),
    /* @__PURE__ */ a("table", { className: "table table-vertical mb-4", children: /* @__PURE__ */ a("tbody", { children: (p || V).map((i, s) => /* @__PURE__ */ x("tr", { children: [
      /* @__PURE__ */ a("th", { children: /* @__PURE__ */ a("div", { children: i == null ? void 0 : i.title }) }),
      /* @__PURE__ */ a("td", { children: _(i, s) })
    ] }, i == null ? void 0 : i.key)) }) })
  ] });
};
export {
  q as ObjectTable
};
